export const DEFAULT_USER = {
    id: null,
    roles: [],
    isLoggedIn: false,
    fname: '',
    lname: '',
    login: () => { },
    logout: () => { }
}

export const DEFAULT_LIST = {
    name: "پیش فرض",
    items: [{
        "name": "sender",
        "field": "pre_createdby"
    },
    {
        "field": "pre_created_at",
        "name": "sent_on"
    },
    {
        "field": "pre_modified_at",
        "name": "sent_by"
    }]
}
export const DEFAULT_WORKFLOW = [{
    "name": "init",
    "label": "ثبت اولیه",
    "meaning": 1,
    "transitions": {
        "end": true,
        "inprog": true,
        "deleted": true
    }
},
{
    "name": "inprog",
    "label": "در حال انجام",
    "meaning": 10,
    "transitions": {
        "init": true
    }
},
{
    "name": "halt",
    "label": "توقف",
    "meaning": 20,
    "transitions": {
        "init": true,
        "inprog": true
    }
},
{
    "name": "end",
    "label": "پایان یافته",
    "meaning": 30,
    "transitions": {
        "inprog": true
    }
},
{
    "name": "deleted",
    "label": "حذف شده",
    "meaning": 40,
    "transitions": {
        "end": true,
        "init": true,
        "inprog": true
    }
}]

export * from './provinces'
export * from './next'
export * from './permissions'
export * from './service'
export * from './settings'
